// Full Bulgarian Location Mapping
export const DELIVERY_LOCATIONS = [
  { id: 'lom', name: 'гр. Лом', defaultFee: 1 },
  { id: 'lom_mladenovo', name: 'гр. Лом - кв. Младеново', defaultFee: 2 },
  { id: 'lom_momin_brod', name: 'гр. Лом - кв. Момин брод', defaultFee: 2 },
  { id: 'zamfir', name: 'с. Замфир', defaultFee: 2 },
  { id: 'kovachitsa', name: 'с. Ковачица', defaultFee: 5 },
  { id: 'staliyska_mahala', name: 'с. Сталийска махала', defaultFee: 5 },
  { id: 'traykovo', name: 'с. Трайково', defaultFee: 5 },
  { id: 'rasovo', name: 'с. Расово', defaultFee: 5 }
];

export const BOX_TYPES = [
  { id: 'small_box', name: 'Малка кутия' },
  { id: 'medium_box', name: 'Средна кутия' },
  { id: 'large_box', name: 'Голяма кутия' },
  { id: 'pizza_box', name: 'Кутия за пица' },
  { id: 'burger_box', name: 'Кутия за бургер' },
  { id: 'no_box', name: 'Без кутия' }
] as const;

export type BoxType = (typeof BOX_TYPES)[number]['id'];

export type BoxName = (typeof BOX_TYPES)[number]['name'];

export interface SystemConfig {
  ordering_enabled: boolean;
  minimum_order_price: number;
  minimum_order_price_outside: number;
  categories: string[];
  box_prices: { [key in BoxType]: number };
  delivery_fees: {
    lom: number;
    lom_mladenovo: number;
    lom_momin_brod: number;
    zamfir: number;
    kovachitsa: number;
    staliyska_mahala: number;
    traykovo: number;
    rasovo: number;
  };
  order_start_hour: number;
  order_end_hour: number;
  track_user_presence?: boolean;
  updated_at?: any;
  updated_by?: string;
}

export interface Address {
  id: string;
  location: string; // One of the 8 allowed locations
  street: string;
  number: string;
  details?: string;
  is_default: boolean;
}

export interface UserProfile {
  uid: string;
  email: string;
  displayName: string;
  phone: string;
  addresses: Address[];
  role: 'customer' | 'admin';
  disabled?: boolean;
  last_active_at?: any;
  created_at: any;
}

export interface MenuItem {
  id?: string;
  name: string;
  description: string;
  price: number;
  box_type: BoxType;
  image_url: string;
  category: string;
  enabled: boolean;
  sort_order?: number;
  created_at?: any;
}

export interface OrderItem {
  menu_item_id: string;
  name: string;
  price: number;
  box_type: BoxType;
  box_price: number;
  quantity: number;
}

export interface PromoCode {
  code: string; // Document ID (uppercase)
  type: 'percent' | 'fixed' | 'free_delivery';
  value: number; // e.g. 10 for 10%, 5 for 5.00 €
  is_active: boolean;
  start_date: any;
  end_date: any;
  min_order_value: number;
  single_use: boolean;
  // Reimbursement Voucher Fields
  assigned_user_id?: string;
  is_used?: boolean;
  is_reimbursement?: boolean;
  original_order_id?: string;
  reason?: string;
}

export interface Order {
  id?: string;
  order_number?: string;
  user_id: string;
  customer_name: string;
  phone: string;
  delivery_address: string; // formatted full address text
  items: OrderItem[];
  subtotal_food: number;
  subtotal_boxes: number;
  delivery_fee: number;
  discount_amount?: number;
  promo_code?: string;
  total: number;
  payment_method: 'card';
  payment_status: 'awaiting_payment' | 'paid' | 'failed' | 'refunded';
  status: 'pending_payment' | 'pending' | 'preparing' | 'delivering' | 'completed' | 'cancelled';
  created_at: any;
  notes?: string;
  email_sent?: boolean;
}

export interface Transaction {
  id?: string;
  order_id: string;
  order_number: string;
  amount: number;
  currency: string;
  status: 'completed' | 'failed' | 'reversed';
  rrn?: string;
  approval_code?: string;
  int_ref?: string;
  rc?: string;
  error_msg?: string;
  reversal_rrn?: string;
  reversal_approval_code?: string;
  reversal_reason?: string;
  reversed_at?: any;
  created_at: any;
}

